import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Dashboard from "@/pages/Dashboard";
import { SalesDashboard, AccountsDashboard } from "@/components/dashboards/SalesAccounts";
import { WarehouseDashboard, LogisticsDashboard, FactoryDashboard } from "@/components/dashboards/OpsDashboards";

const VIEWS = { sales: SalesDashboard, accounts: AccountsDashboard, warehouse: WarehouseDashboard, logistics: LogisticsDashboard, factory: FactoryDashboard };
const KINDS = ["management", "sales", "accounts", "warehouse", "logistics", "factory"];

export default function RoleDashboard() {
  const { user } = useAuth();
  const [kind, setKind] = useState(null);
  const [res, setRes] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await api.get(`/dashboard/role${kind ? `?kind=${kind}` : ""}`);
      setRes(r.data); setError(null);
    } catch { setError("Failed to load dashboard"); }
  }, [kind]);

  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);

  if (error) return <p className="text-signal-red" data-testid="role-dashboard-error">{error}</p>;
  if (!res) return <div className="flex justify-center py-20"><div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div>;
  const View = VIEWS[res.dashboard];
  return (
    <div className="space-y-4" data-testid="role-dashboard" data-kind={res.dashboard}>
      {user?.role === "admin" && (
        <div className="flex flex-wrap gap-1" data-testid="dashboard-kind-switch">
          {KINDS.map((k) => (
            <button key={k} onClick={() => setKind(k)} className={`text-[10px] font-mono uppercase tracking-widest px-2 py-1 rounded border transition-colors ${res.dashboard === k ? "bg-primary/15 text-primary border-primary/40" : "border-border text-muted-foreground hover:text-foreground"}`} data-testid={`dashboard-kind-${k}`}>{k}</button>))}
        </div>)}
      {View ? <View d={res.data} user={res.user} /> : <Dashboard />}
    </div>
  );
}
